import { createFileRoute } from '@tanstack/react-router';

import { WhatsAppSettingsPage } from '@/features/whatsapp/pages/whatsapp-settings';

export const Route = createFileRoute('/_app/settings/whatsapp')({
  component: WhatsAppSettingsPage,
});
